import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAuthModal } from "../context/AuthModalContext";
import { getProfileUserId } from "../utils/userDisplay";

/**
 * Renders @username as a link to /profile/:userId when both are available.
 */
const UsernameLink = ({
  userId,
  username,
  user,
  className = "",
  prefix = "@",
  fallback = "—",
  stopPropagation = false,
}) => {
  const id = userId || getProfileUserId(user);
  const handle = username || user?.username;
  const label = handle ? `${prefix}${handle}` : fallback;
  const { isAuthenticated } = useAuth();
  const authModal = useAuthModal();

  const handleClick = (e) => {
    if (stopPropagation) e.stopPropagation();
    if (!isAuthenticated && authModal) {
      e.preventDefault();
      authModal.openAuthModal({ redirectTo: `/profile/${id}` });
    }
  };

  if (!id || !handle) {
    return <span className={className}>{label}</span>;
  }
  return (
    <Link
      to={`/profile/${id}`}
      onClick={handleClick}
      className={`transition hover:text-accent-text ${className}`}
    >
      {label}
    </Link>
  );
};

export default UsernameLink;
